import { isOrganisationPaymentMode } from "@/services/organisationRegistrationFormApi";

export const planMixin = {
    methods: {
        getPlanDisplayLabel(plan, hidePrices) {
            if (hidePrices) return plan.name

            var name = plan.name;

            var price = plan.price.toLocaleString(undefined, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
            });

            var registrationFee = plan.registrationFee
                ? plan.registrationFee.toLocaleString(undefined, {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                })
                : null;


            var remittanceFee = plan.remittanceFee
                ? plan.remittanceFee.toLocaleString(undefined, {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                })
                : null;

            var transferFee = plan.transferFee
                ? plan.transferFee.toLocaleString(undefined, {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                })
                : null;

            var discountFee = plan.discountFee
                ? plan.discountFee.toLocaleString(undefined, {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                })
                : null;

            var administrationFee = plan.administrationFee
                ? plan.administrationFee.toLocaleString(undefined, {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                })
                : null;


            var pricePart =
                `(€ ${price}` +
                (registrationFee
                    ? ` + € ${registrationFee} ${this.$t("registration_fee")}`
                    : "") +
                (remittanceFee
                    ? ` + € ${remittanceFee} ${plan.remittanceDescription || this.$t("remittance_fee")}`
                    : "") +
                (transferFee
                    ? ` + € ${transferFee} ${this.$t("transfer_fee")}`
                    : "") +
                (discountFee
                    ? ` + € ${discountFee} ${this.$t("discount_fee")}`
                    : "") +
                (administrationFee
                    ? ` + € ${administrationFee} ${this.$t("administration_fee")}`
                    : "") +
                ")";

            return `${name} ${pricePart}`;
        },
        // Organisation plan options only carry a price, in the tenant's
        // currency (currencyCode on the organisation form).
        formatOrganisationPlanPrice(amount, currencyCode) {
            return amount.toLocaleString(undefined, {
                style: "currency",
                currency: currencyCode || "EUR",
            });
        },
        // FOYS-27334: payment-mode forms show the part always invoiced for the
        // plan (totalPrice = price + remittance fee - discount), falling back to
        // price. Send manually forms keep showing price.
        getOrganisationPlanPrice(plan, formConfig) {
            if (isOrganisationPaymentMode(formConfig) && typeof plan.totalPrice === "number") {
                return plan.totalPrice;
            }

            return typeof plan.price === "number" ? plan.price : null;
        },
        getOrganisationPlanLabel(plan, formConfig) {
            const price = this.getOrganisationPlanPrice(plan, formConfig);

            if (price === null) return plan.name;

            return `${plan.name} (${this.formatOrganisationPlanPrice(price, formConfig.currencyCode)})`;
        },
    }
}